import React, { useEffect, useRef, useState } from "react";
import { Grid, TextField, Box, Button, Autocomplete } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "@mui/material";

import "./user.scss";
import { User } from "./type/user";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowBack from "@mui/icons-material/ArrowBack";
import PersonOutline from "@mui/icons-material/PersonOutline";
import MailOutline from "@mui/icons-material/MailOutline";
import Business from "@mui/icons-material/Business";
import Security from "@mui/icons-material/Security";
import PersonAdd from "@mui/icons-material/PersonAdd";
import { InputAdornment } from "@mui/material";
import {
  addNewUser,
  editUser,
  fetchUserById,
} from "../../store/slices/User/thunk";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";
import { fetchCompany } from "../../store/slices/Company/thunk";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";
const AddUser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const tenantConfig = getTenantConfigFromStorage();
  const schoolLabel = tenantConfig.labels.school;

  const [user, setUser] = useState({
    name: "",
    email: "",
    userName: "none",
    password: "",
    role: "admin",
    company: [],
    // userPermission: [
    //   {
    //     vehicle: {
    //       isAllList: false,
    //       isDetailView: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     vehicleGroup: {
    //       isAllList: false,
    //       isAddNew: false,
    //       isDelete: false,
    //     },
    //     driver: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     bookings: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     customer: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     fuel: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     reminder: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     incomeExpense: {
    //       isAllList: false,
    //       isEdit: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     maintenance: {
    //       isAllList: false,
    //       isAdd: false,
    //     },
    //     availibity: {
    //       isAllList: false,
    //     },
    //     tracking: {
    //       isHistoryTracking: false,
    //       isLiveLocation: false,
    //     },
    //     geofence: {
    //       isAllList: false,
    //       isEventsList: false,
    //       isAdd: false,
    //       isDelete: false,
    //     },
    //     reports: {
    //       viewReports: false,
    //     },
    //     settings: {
    //       allSettings: false,
    //     },
    //   },
    // ],
    _id: "",
  });
  const { id } = useParams<any>();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch: any = useDispatch();
  const [searchCompany, setSearchCompany] = React.useState("");
  const [allCompany, setAllCompany] = useState<any>([]);
  const [companyId, setCompanyId] = useState<string>("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // const handleNameChange = (e: any) => {
  //   setUser((prevState) => ({
  //     ...prevState,
  //     name: e.target.value,
  //   }));
  // };
  const handleCustomerRemove = (customerId: string) => {
    const updated = user.company.filter(
      (cust: any) => cust.companyId !== customerId
    );
    setUser((prev: any) => ({
      ...prev,
      company: updated,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchUserById(id));
        const { name, email, userName, userPermission, role, company, _id } =
          response.data; // 🔥 Required fields

        setUser({
          name,
          email,
          userName,
          password: "",
          role,
          company,
          // userPermission: userPermission?.length ? [userPermission[0]] : [],
          _id,
        });
        console.log(user);
        // navigate(`/editUser/${id}`);
      } else {
        setIsEdit(false);
        setUser({
          name: "",
          email: "",
          userName: "none",
          password: "",
          role: "admin",
          company: [],
          // userPermission: [
          //   {
          //     vehicle: {
          //       isAllList: false,
          //       isDetailView: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     vehicleGroup: {
          //       isAllList: false,
          //       isAddNew: false,
          //       isDelete: false,
          //     },
          //     driver: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     bookings: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     customer: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     fuel: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     reminder: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     incomeExpense: {
          //       isAllList: false,
          //       isEdit: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     maintenance: {
          //       isAllList: false,
          //       isAdd: false,
          //     },
          //     availibity: {
          //       isAllList: false,
          //     },
          //     tracking: {
          //       isHistoryTracking: false,
          //       isLiveLocation: false,
          //     },
          //     geofence: {
          //       isAllList: false,
          //       isEventsList: false,
          //       isAdd: false,
          //       isDelete: false,
          //     },
          //     reports: {
          //       viewReports: false,
          //     },
          //     settings: {
          //       allSettings: false,
          //     },
          //   },
          // ],
          _id: "",
        });
        // navigate("/addUser");
      }
    };
    fetchData();
  }, [id, navigate, dispatch]);

  // Handle email change
  // const handleEmailChange = (e: any) => {
  //   setUser((prevState) => ({
  //     ...prevState,
  //     email: e.target.value,
  //   }));
  // };

  // Handle userName change
  const handleChange = (e: any) => {
    // const { value } = e.target;
    // const inputName = e.target.name;
    let { name: inputName, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [inputName]: value,
    }));
  };

  const passwordRef = useRef<any>(null);
  // const handlePasswordChange = () => {
  //   setUser((prevState) => ({
  //     ...prevState,
  //     password: passwordRef.current.value,
  //   }));
  // };

  const handleCheckboxChange =
    (category: any, permission: any) => (event: any) => {
      const { checked } = event.target;
      setUser((prevUser: any) => {
        const updatedPermissions = prevUser.userPermission.map(
          (permissionSet: any, index: any) => {
            if (index === 0) {
              return {
                ...permissionSet,
                [category]: {
                  ...permissionSet[category],
                  [permission]: checked,
                },
              };
            }
            return permissionSet;
          }
        );

        return { ...prevUser, userPermission: updatedPermissions };
      });
    };
  const navigateTUserList = () => {
    navigate("/user-list");
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Sending:", user);
    setLoading(true);
    if (
      !user.name ||
      !user.email ||
      !user.userName ||
      !user.role ||
      !user.company[0]
    ) {
      toast("Please fill all required fields!");
      setLoading(false);
      return;
    }
    try {
      if (isEdit) {
        const res: any = await dispatch(editUser(user));
        const result = res;
        console.log("Success:", result);
        toast("User Edited!");
        navigate("/user-list");
      } else {
        const res: any = await dispatch(addNewUser(user));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast("User added!");
          navigate("/user-list");
        } else {
          toast("User Not added!");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const getAllCompany = async () => {
      const response: any = await dispatch(
        fetchCompany(1, 99999999, searchCompany, "")
      );
      if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
        setAllCompany(response?.data?.data);
      } else {
        setAllCompany([]);
      }
      console.log(allCompany);
    };

    getAllCompany();
  }, [dispatch]);
  //   const handleChangeForCompany = (e: any) => {
  //   const { value } = e.target;
  //   setCompanyId(value);
  //   if (!value) {
  //     setUser({
  //       ...user,
  //       company: [],
  //     });
  //     return;
  //   }
  //   const selectedCompany: any = allCompany.find(
  //     (company: any) => company._id === value
  //   );

  //   if (selectedCompany) {
  //     // addNewUser({
  //     //   ...user,
  //     //   company: {
  //     //     companyId: selectedCompany?._id,
  //     //     companyName: selectedCompany?.companyName,
  //     //   },
  //     // });
  //     // setUser({
  //     //   ...user,
  //     //   company: [
  //     //     {
  //     //       companyId: selectedCompany?._id,
  //     //       companyName: selectedCompany?.companyName,
  //     //     }
  //     //   ],
  //     // })
  //     // user.company.push({
  //     //   companyId: selectedCompany?._id,
  //     //   companyName: selectedCompany?.companyName,
  //     // })
  //   }
  // };
  const handleChangeForCompany = (event: any) => {
    const selectedIds: string[] = event?.target?.value;

    setUser((prev: any) => {
      const preserved = prev.company.filter((c: any) =>
        selectedIds.includes(c.companyId)
      );

      const newOnes = selectedIds
        .filter((id) => !preserved.some((c: any) => c.companyId === id))
        .map((id) => {
          const found: any = allCompany.find((c: any) => c._id === id);

          return {
            companyId: found._id,
            companyName: found.companyName,
          };
        });

      const updated = [...preserved, ...newOnes];

      return {
        ...prev,
        company: updated,
      };
    });
  };

  return (
    <div style={{ backgroundColor: "transparent", minHeight: "100vh", padding: "24px 15px", display: "flex", flexDirection: "column" }}>
      <div className="container" style={{ maxWidth: "1200px", flex: 1, display: "flex", flexDirection: "column" }}>
        <ToastContainer />

        {/* Top Navigation */}
        <div className="d-flex align-items-center gap-3 mb-4">
          <button
            onClick={navigateTUserList}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "#3b82f6",
              flexShrink: 0,
            }}
          >
            <ArrowBack fontSize="small" />
          </button>
          <div>
            <h2 className="fw-bold m-0" style={{ color: "#0f172a", fontSize: "24px", fontFamily: "sans-serif", lineHeight: 1.2 }}>
              {isEdit ? "Edit User" : "Add User"}
            </h2>
            <p className="m-0" style={{ color: "#64748b", fontSize: "14px" }}>
              Fill in the user information to create account
            </p>
          </div>
        </div>

        {/* Main Card */}
        <div className="card border-0 shadow-sm p-4 p-md-5" style={{ borderRadius: "20px", backgroundColor: "#ffffff" }}>
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="d-block mb-2 fw-semibold" style={{ fontSize: "14px", color: "#1e293b" }}>
                Name <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <TextField
                fullWidth
                name="name"
                value={user.name}
                onChange={handleChange}
                placeholder="Enter full name"
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    height: "50px",
                    "& fieldset": { borderColor: "#e2e8f0" },
                    "&:hover fieldset": { borderColor: "#94a3b8" },
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutline fontSize="small" sx={{ color: "#3b82f6" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className="col-md-6 mb-2">
              <label className="d-block mb-2 fw-semibold" style={{ fontSize: "14px", color: "#1e293b" }}>
                Email <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <TextField
                fullWidth
                name="email"
                type="email"
                value={user.email}
                onChange={handleChange}
                placeholder="Enter email address"
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    height: "50px",
                    "& fieldset": { borderColor: "#e2e8f0" },
                    "&:hover fieldset": { borderColor: "#94a3b8" },
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutline fontSize="small" sx={{ color: "#3b82f6" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* <div className="col-md-6">
              <h6>User Name <span style={{color:'red'}}>*</span></h6>
              <TextField
                fullWidth
                name="userName"
                value={user.userName}
                onChange={handleChange}
              />
            </div> */}

            {/* {!isEdit && (
              <div className="col-md-6">
                <h6>Password <span style={{color:'red'}}>*</span></h6>

                <div
                  className="input inputUrgent"
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="***"
                                    name="password"
                    value={user.password}
                    onChange={handleChange}
                    style={{ paddingRight: "30px" }} 
                  />
                  <span
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      cursor: "pointer",
                      color: "#888",
                    }}
                  >
                    {showPassword ? <IoEyeOff /> : <IoEye />}
                  </span>
                </div>
              </div>
            )} */}
            <div className="col-md-6 mb-2">
              <label className="d-block mb-2 fw-semibold" style={{ fontSize: "14px", color: "#1e293b" }}>
                {`Select ${schoolLabel}`} <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div
                style={{ position: "relative", width: "100%" }}
                className="col-md-12"
              >
                <Box sx={{ minWidth: 120, padding: 0 ,paddingRight:0 }}>
                  <Autocomplete
                    multiple
                    options={allCompany}
                    className="p-0"
                    disableCloseOnSelect
                    getOptionLabel={(option: any) => option.companyName}
                    value={allCompany.filter((cust: any) =>
                      user.company.some((c: any) => c.companyId === cust._id)
                    )}
                    onChange={(event, newValue: any[]) => {
                      const selectedIds = newValue.map((cust: any) => cust._id);
                      handleChangeForCompany({
                        target: { value: selectedIds },
                      });
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.companyName}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Search or select ${schoolLabel.toLowerCase()}`}
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            height: "50px",
                            "& fieldset": { borderColor: "#e2e8f0" },
                            "&:hover fieldset": { borderColor: "#94a3b8" },
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                <Business fontSize="small" sx={{ color: "#3b82f6" }} />
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderTags={() => null}
                    ListboxProps={{
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        "& .MuiAutocomplete-option": {
                          color: "#000",padding:"0 !important"
                        },
                        
                      },
                    }}
                  />
                </Box>
                {user.company.length > 0 && (
                  <>
                  <div className="d-flex w-100  mt-2 gap-2 flex-wrap">
                    {user.company.map((companyItem: any) => (
                      <div
                        key={companyItem.companyId}
                        className="selectedCompany"
                      >
                        {`Selected ${schoolLabel}: ${companyItem.companyName}`}
                      </div>
                    ))}
                    </div>
                  </>
                )}

                {/* <span
                                      style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        pointerEvents: "none",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        style={{ color: "#6B7280" }}
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M19 9l-7 7-7-7"
                                        />
                                      </svg>
                                    </span> */}
              </div>
            </div>
            <div className="col-md-6 mb-2">
              <label className="d-block mb-2 fw-semibold" style={{ fontSize: "14px", color: "#1e293b" }}>
                Select Role <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <TextField
                select
                fullWidth
                name="role"
                value={user.role}
                onChange={handleChange}
                variant="outlined"
                SelectProps={{ native: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    height: "50px",
                    "& fieldset": { borderColor: "#e2e8f0" },
                    "&:hover fieldset": { borderColor: "#94a3b8" },
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Security fontSize="small" sx={{ color: "#3b82f6" }} />
                    </InputAdornment>
                  ),
                }}
              >
                <option value="admin">Admin</option>
                <option value="schoolAdmin">{`${schoolLabel} Admin`}</option>
              </TextField>
            </div>
          </div>

        {/* <div className="mt-5">
          <div className="container">
            <h5 className="usEr">User Permission's</h5>
          </div>

          <div className="container mt-5">
            <div className="row">
              <div className="col-md-3">
                <h6>Vehicle</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isAllList}
                      onChange={handleCheckboxChange("vehicle", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isDetailView}
                      onChange={handleCheckboxChange("vehicle", "isDetailView")}
                    />
                  }
                  label={<Typography fontWeight={700}>Detail View</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isEdit}
                      onChange={handleCheckboxChange("vehicle", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2 d-flex">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isAdd}
                      onChange={handleCheckboxChange("vehicle", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add</Typography>}
                />
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.vehicle?.isDelete}
                      onChange={handleCheckboxChange("vehicle", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2"></div>{" "}
            </div>
          </div>

          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Vehicle Group</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "vehicleGroup",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isAddNew
                      }
                      onChange={handleCheckboxChange("vehicleGroup", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.vehicleGroup?.isDelete
                      }
                      onChange={handleCheckboxChange(
                        "vehicleGroup",
                        "isDelete"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Driver</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isAllList}
                      onChange={handleCheckboxChange("driver", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isEdit}
                      onChange={handleCheckboxChange("driver", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isDelete}
                      onChange={handleCheckboxChange("driver", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.driver?.isAdd}
                      onChange={handleCheckboxChange("driver", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Booking</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isAllList}
                      onChange={handleCheckboxChange("bookings", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All Booking</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isEdit}
                      onChange={handleCheckboxChange("bookings", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isAdd}
                      onChange={handleCheckboxChange("bookings", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.bookings?.isDelete}
                      onChange={handleCheckboxChange("bookings", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Customer</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isAllList}
                      onChange={handleCheckboxChange("customer", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isEdit}
                      onChange={handleCheckboxChange("customer", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isAdd}
                      onChange={handleCheckboxChange("customer", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.customer?.isDelete}
                      onChange={handleCheckboxChange("customer", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2 ">
            <div className="row">
              <div className="col-md-3">
                <h6>Fuel</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isAllList}
                      onChange={handleCheckboxChange("fuel", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>Fuel List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isEdit}
                      onChange={handleCheckboxChange("fuel", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isAdd}
                      onChange={handleCheckboxChange("fuel", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.fuel?.isDelete}
                      onChange={handleCheckboxChange("fuel", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2 mb-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Reminder</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isAllList}
                      onChange={handleCheckboxChange("reminder", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isDelete}
                      onChange={handleCheckboxChange("reminder", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isAdd}
                      onChange={handleCheckboxChange("reminder", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reminder?.isDelete}
                      onChange={handleCheckboxChange("reminder", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Income Expense</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.incomeExpense?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "incomeExpense",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.incomeExpense?.isEdit}
                      onChange={handleCheckboxChange("incomeExpense", "isEdit")}
                    />
                  }
                  label={<Typography fontWeight={700}>Edit</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.incomeExpense?.isAdd}
                      onChange={handleCheckboxChange("incomeExpense", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add New</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.incomeExpense?.isDelete
                      }
                      onChange={handleCheckboxChange(
                        "incomeExpense",
                        "isDelete"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Maintenace</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.maintenance?.isAllList
                      }
                      onChange={handleCheckboxChange(
                        "maintenance",
                        "isAllList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Maintenace</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.maintenance?.isAdd}
                      onChange={handleCheckboxChange("maintenance", "isAdd")}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>Maintenace Add</Typography>
                  }
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Availablity</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.availibity?.isAllList}
                      onChange={handleCheckboxChange("availibity", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>Availablity</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Tracking</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.tracking?.isHistoryTracking
                      }
                      onChange={handleCheckboxChange(
                        "tracking",
                        "isHistoryTracking"
                      )}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>History Tracking</Typography>
                  }
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.tracking?.isLiveLocation
                      }
                      onChange={handleCheckboxChange(
                        "tracking",
                        "isLiveLocation"
                      )}
                    />
                  }
                  label={
                    <Typography fontWeight={700}>Live Location</Typography>
                  }
                />
              </div>{" "}
            </div>
          </div>

          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Geofence</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isAdd}
                      onChange={handleCheckboxChange("geofence", "isAdd")}
                    />
                  }
                  label={<Typography fontWeight={700}>Add</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isAllList}
                      onChange={handleCheckboxChange("geofence", "isAllList")}
                    />
                  }
                  label={<Typography fontWeight={700}>All List</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.geofence?.isDelete}
                      onChange={handleCheckboxChange("geofence", "isDelete")}
                    />
                  }
                  label={<Typography fontWeight={700}>Delete</Typography>}
                />
              </div>{" "}
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={
                        user?.userPermission?.[0]?.geofence?.isEventsList
                      }
                      onChange={handleCheckboxChange(
                        "geofence",
                        "isEventsList"
                      )}
                    />
                  }
                  label={<Typography fontWeight={700}>Events</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-3">
                <h6>Reports</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.reports?.viewReports}
                      onChange={handleCheckboxChange("reports", "viewReports")}
                    />
                  }
                  label={<Typography fontWeight={700}>View Reports</Typography>}
                />
              </div>{" "}
            </div>
          </div>
          <div className="container mt-2 mb-3">
            <div className="row">
              <div className="col-md-3">
                <h6>Settings</h6>
              </div>
              <div className="col-md-2">
                <FormControlLabel
                  className="checkbox-label"
                  control={
                    <Checkbox
                      checked={user?.userPermission?.[0]?.settings?.allSettings}
                      onChange={handleCheckboxChange("settings", "allSettings")}
                    />
                  }
                  label={<Typography fontWeight={700}>All Settings</Typography>}
                />
              </div>{" "}
            </div>
          </div>
        </div> */}

          {/* Action Button */}
          <div className="d-flex justify-content-end mt-2">
            <Button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                textTransform: "none",
                fontWeight: "600",
                height: "44px",
                padding: "0 24px",
                borderRadius: "10px",
                backgroundColor: "#0066ff",
                color: "#ffffff",
                boxShadow: "0 4px 6px -1px rgba(0, 102, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "15px",
              }}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {isEdit ? "Edit..." : "Add..."}
                </>
              ) : (
                <>
                  <PersonAdd fontSize="small" />
                  {isEdit ? "Edit User" : "Add User"}
                </>
              )}
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-4" style={{ fontSize: "13px", color: "#94a3b8", fontFamily: "sans-serif" }}>
          © 2024 Van Wala Operations System. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default AddUser;
